import React from 'react'
import MejoresCarrerasComponent from '../componets/Universidades/MejoresCarrerasComponent'
import NavBar from '../componets/General/NavBar'
import Footer from '../componets/General/Footer'
class MejoresCarreras extends React.Component{

    componentDidMount(){
        window.scrollTo(0,0);
    }
    render(){
        return(
            <div>
                <NavBar/>
                <MejoresCarrerasComponent/>
                <Footer/>
            </div>
        )
    }
}
    

export default MejoresCarreras